export const tokens = {
    gap: 4,
    fontSize: 12,
};
